import * as S from './link.styles'

import { ILinkProps } from './link.types'

const Link = ({ children, icon, iconPosition, size, ...props }: ILinkProps) => {
  return (
    <S.LinkContainer $iconPosition={iconPosition} {...props}>
      <S.LinkTypography size={size}>{children}</S.LinkTypography>
      {icon}
    </S.LinkContainer>
  )
}

export { Link }
